// Confirmaciones con la ventana propia del sistema, en vez del cartel del navegador
// ("accionsocial.munisanroque.ar dice…"). Se usan igual que window.confirm/prompt,
// pero devuelven una promesa:
//
//   if (!(await confirmar({ titulo: '¿Eliminar el vale?', mensaje: '…', accion: 'Eliminar' }))) return
//   const motivo = await pedirTexto({ titulo: 'Dar de baja', etiqueta: 'Motivo' })  // null si cancela
//
// La ventana la dibuja <Confirmador />, montado una sola vez en App.

export const canalConfirmacion = { abrir: null }

const pedir = (opciones) => new Promise((resolve) => {
  if (!canalConfirmacion.abrir) {
    // Sin la ventana montada (no debería pasar) no se bloquea la acción: se usa la del navegador.
    resolve(opciones.conTexto ? window.prompt(opciones.mensaje || opciones.titulo) : window.confirm(opciones.mensaje || opciones.titulo))
    return
  }
  canalConfirmacion.abrir({ ...opciones, resolve })
})

/**
 * @param {{ titulo: string, mensaje?: string, accion?: string, peligro?: boolean } | string} opciones
 * @returns {Promise<boolean>}
 */
export const confirmar = (opciones) => pedir(typeof opciones === 'string' ? { titulo: opciones } : opciones)

/**
 * @param {{ titulo: string, mensaje?: string, etiqueta?: string, accion?: string, peligro?: boolean,
 *           obligatorio?: boolean, placeholder?: string }} opciones
 * @returns {Promise<string|null>} el texto escrito, o null si se canceló.
 */
export const pedirTexto = (opciones) => pedir({ ...opciones, conTexto: true })
